import { render } from "./ResolveReason.vue?vue&type=template&id=1cdaa72f&ts=true"
import script from "./ResolveReason.vue?vue&type=script&lang=ts"
export * from "./ResolveReason.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__